// @ts-nocheck
import { createHandlerChainRunnerOptionalParameter, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const ClearForm: Handler = props => {
    props.dispatch({
        type: "Greif/Components/InviteYourColleagueForm/ClearForm",
    });
};

export const chain = [ClearForm];

const clearForm = createHandlerChainRunnerOptionalParameter(chain, {}, "ClearForm");
export default clearForm;
